import React from 'react';
import Layout from 'components/Layout';
import { Box, Grid, Container, Typography } from '@mui/material';

import { AccountInfo } from 'components/Account';
import i18n from 'i18n-js';

const AccountPage = () => {
  return (
    <Layout title={i18n.t('account.title')}>
      <Container sx={{ minWidth: '100%', m: 0 }}>
        <Grid container spacing={0}>
          <Grid size={{ xs: 12 }}>
            <Typography variant="h6" gutterBottom>
              <Box fontWeight="fontWeightBold" data-cy="title" fontSize={24} mt={2} mb={3}>
                {i18n.t('account.title')}
              </Box>
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <AccountInfo />
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export default AccountPage;
